export enum PageType {
  Category = 'category',
  Partner = 'partner',
  Search = 'search',
  Taxonomy = 'taxonomy',
}

export type FilterNavType = 'sticky filter' | 'collapsed sidebar' | 'fixed sidebar';
